import { Scope } from '../scope';
import { updateFixedStageState } from './updateFixedStageState';

export const skipMigrationAndUpdateFixedState = (scope: Scope) => {
  updateFixedStageState(scope);
  scope.migrationHook.resolve();
};
